import React from 'react'
import styles from './AuthorHome.module.css'
import { Col, Divider, Row } from 'antd'
import Title from 'antd/es/typography/Title'
import { FeaturedCollectionCard } from '../SmallComponents/SmallComponents'
import MultipleSlider from '../Multiple Slider/MultipleSlider'
import EmptyData from '../EmptyData/EmptyData'

type Props = {
    pinnedCollection :any,
    authorDetailsLoading:any,
    featuredCollections:any,
    topCollections:any,
}

const AuthorHome = (props: Props) => {
    const {pinnedCollection, authorDetailsLoading, featuredCollections, topCollections} = props;
  return (
    <>
    
    <Row justify={"space-between"} style={{rowGap: "30px", width: "100%"}} gutter={20}>
            {
      (typeof pinnedCollection === 'undefined' || pinnedCollection !== false)
       ?
        <>
        <FeaturedCollectionCard loading={authorDetailsLoading} data={pinnedCollection}/>
    <Divider style={{margin: "0"}}/>
    </> : null
          }

    {featuredCollections?.length > 0 ? 
      <Col span={24}>
          <Title style={{margin: "10px 0"}} level={3}>Featured Collections</Title>
      <MultipleSlider featured={true} loading={authorDetailsLoading} data={featuredCollections} />
      </Col>
             : 
             <Row justify={"center"} align={'middle'} style={{rowGap: "20px", minHeight: "200px", width: "100%"}}  gutter={20}>
             <EmptyData description={`No Collections`} buttonText={null} buttonOnClick={()=> console.log("")} />
             </Row>
      }

    <Divider style={{margin: "0"}}/>
    
    {topCollections?.length > 0 ?
    
      <Col span={24}>
      <Title style={{margin: "10px 0"}} level={3}>Top Collections</Title>
        <MultipleSlider loading={authorDetailsLoading} data={topCollections} />
      </Col>
         : 
         <Row justify={"center"} align={'middle'} style={{rowGap: "20px", minHeight: "200px", width: "100%"}}  gutter={20}>
         <EmptyData description={`No Collections`} buttonText={null} buttonOnClick={()=> console.log("")} />
         </Row>
  }

      </Row>
    </>
  )
}

export default AuthorHome